module.exports = __webpack_public_path__ + "static/media/lockRed.8deb40df.svg";